var map = {
	"./Privacy Policy.png": 902,
	"./Terms and Conditions.png": 46,
	"./background.png": 123,
	"./buzz.gif": 529,
	"./contact.png": 91,
	"./cursor.png": 60,
	"./email.png": 89,
	"./legal.png": 250,
	"./logo.png": 873,
	"./logo60x60.png": 336,
	"./logoDisk.png": 839,
	"./planet.gif": 54,
	"./services.png": 688,
	"./team.png": 294,
	"./trash.png": 615,
	"./twitter.png": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;